import * as React from "react";
import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';
import {
  Card,
  List,
  Input
} from ".."
import * as styles from "./styles.scss";

export class Person{
  @observable
  public id: string = '';
  @observable
  public email: string = '';
  @observable
  public name: string = '';
  @observable
  public surname: string = '';
  @observable
  public error: string = '';

  @action
  setEmail(value: string){
    this.email = value;
    this.error = '';
  }

  @computed
  get isValidEmail(){
    return /^.+@.+\..+$/i.test(this.email);
  }
}

@observer
export class PersonList extends React.Component<
  {
    persons: Person[];
    userinfoUrl: string;
    header?: any;
    footer?: any;
  },
  {}
>{
  @observable
  private persons: Person[] = [];

  constructor(params: any){
    super(params);

    this.persons = params.persons;
  }

  // Listener
  @action
  async blurPerson(person: Person){
    if(person.email === ''){
      person.id = '';
      person.name = '';
      person.surname = '';
      return;
    }
    if(!person.isValidEmail){
      person.error = 'Пожалуйста, введите корректный адрес электронной почты';
    }

    const response = await fetch(this.props.userinfoUrl + '&login=' + person.email);
    const data = await response.json();
    if(data.result === 'ok' && data.message === 'ok'){
      person.id = data.data.id;
      person.name = data.data.name;
      person.surname = data.data.surname;
    }
    else if(data.result === 'error'){
      person.id = '';
      person.email = '';
      person.name = '';
      person.surname = '';
      person.error = data.message;
    }
  }

  // Render
  renderPerson(person: Person, index: number){
    return (
      <List.Item key={index}>
        <div className={styles.person}>
          <div className={styles.personFields}>
            <div className={styles.personCounter}>{index + 1}.</div>
            <Input
              className={styles.personInput}
              placeholder="E-mail адрес"
              value={person.email}
              onChange={(e: any) => person.setEmail(e.target.value)}
              onBlur={this.blurPerson.bind(this, person)}
            />
            <Input
              className={styles.personInput}
              placeholder="Имя"
              value={person.name}
              onChange={(e: any) => person.name = e.target.value}
            />
            <Input
              className={styles.personInput}
              placeholder="Фамилия"
              value={person.surname}
              onChange={(e: any) => person.surname = e.target.value}
            />
          </div>
          {person.error !== ''?
            <div className={styles.fieldError}>{person.error}</div>
            : null
          }
        </div>
      </List.Item>
    );
  }

  render(){
    return (
      <div>
        <Card header={this.props.header} footer={this.props.footer}>
          <List>
            {this.persons.map(this.renderPerson, this)}
          </List>
        </Card>
      </div>
    );
  }
}
